<template>
    <div class="form-group">
        <kendo-dropdown
            :value="id"
            @input="input => id = input.value"
            :label="i18n('Common.Dealer')"
            :index="1"
            :dataSource="groupsDataSource">
        </kendo-dropdown>
        <kendo-datepicker
            name="periodDate"
            v-model="periodDate"
            depth="year"
            format="M/yyyy"
            :placeholder="i18n('Common.ReferenceDate')">
        </kendo-datepicker>
    </div>
</template>

<script>
import _ from 'lodash';

import { i18nMixin, momentMixin } from '../../../shared/mixins';
import { loading, unloading, notify, NOTIFY_TYPE } from '../../../../scripts/shared';
import environment from '../../../../scripts/environment';

import KendoDropdown from '../../../shared/components/kendo-dropdown/kendo-dropdown.component';
import KendoDatepicker from '../../../shared/components/kendo-datepicker/kendo-datepicker.component';
import { GroupMakertShareSpreadsheet } from '../../../../spreadsheets/group-market-share-spreadsheet';

export default {
    name: 'download-customers-retention',

    props: {},

    computed: {},

    data () {
        const groupsDataSource = _(environment.get('CONFIG.FILTERS.GROUPS_NAME'))
            .map(val => ({ text: val.text, value: val.text }))
            .orderBy(val => val.text)
            .value();

        return {
            id: groupsDataSource[0].value,
            periodDate: this.moment().startOf('month').subtract(1, 'month').toDate(),
            groupsDataSource
        };
    },

    watch: {},

    mixins: [i18nMixin, momentMixin],

    methods: {
        saveAsExcel () {
            loading();
            setTimeout(() => {
                if (!_.size([1])) {
                    notify(NOTIFY_TYPE.LOG, 'Sem dados de retenção para a loja selecionada.');
                    return unloading(true);
                }

                const dataSource = _.map(_.range(0, 1000), i => ({
                    areaName: `<area_name_${i}>`,
                    dealerNumber: i,
                    groupName: `<group_name_${i}>`,
                    tabName: 'group',
                    areaDealer: {
                        smallLowCoreSedan: _.random(0, 100),
                        smallLowCoreHatchBack: _.random(0, 100),
                        smallLowCore: _.random(0, 100),
                        midSedan: _.random(0, 100),
                        midPickUp: _.random(0, 100),
                        midSUV: _.random(0, 100),
                        midHatchBack: _.random(0, 100),
                        smallSUV: _.random(0, 100),
                        largeSedan: _.random(0, 100),
                        others: _.random(0, 100)
                    },
                    areaGroup: {
                        smallLowCoreSedan: _.random(0, 100),
                        smallLowCoreHatchBack: _.random(0, 100),
                        smallLowCore: _.random(0, 100),
                        midSedan: _.random(0, 100),
                        midPickUp: _.random(0, 100),
                        midSUV: _.random(0, 100),
                        midHatchBack: _.random(0, 100),
                        smallSUV: _.random(0, 100),
                        largeSedan: _.random(0, 100),
                        others: _.random(0, 100)
                    },
                    areaToyota: {
                        smallLowCoreSedan: _.random(0, 100),
                        smallLowCoreHatchBack: _.random(0, 100),
                        smallLowCore: _.random(0, 100),
                        midSedan: _.random(0, 100),
                        midPickUp: _.random(0, 100),
                        midSUV: _.random(0, 100),
                        midHatchBack: _.random(0, 100),
                        smallSUV: _.random(0, 100),
                        largeSedan: _.random(0, 100),
                        others: _.random(0, 100)
                    },
                    areaIndustry: {
                        smallLowCoreSedan: _.random(0, 100),
                        smallLowCoreHatchBack: _.random(0, 100),
                        smallLowCore: _.random(0, 100),
                        midSedan: _.random(0, 100),
                        midPickUp: _.random(0, 100),
                        midSUV: _.random(0, 100),
                        midHatchBack: _.random(0, 100),
                        smallSUV: _.random(0, 100),
                        largeSedan: _.random(0, 100),
                        others: _.random(0, 100)
                    },
                    areaMono: {
                        smallLowCoreSedan: _.random(0, 100),
                        smallLowCoreHatchBack: _.random(0, 100),
                        smallLowCore: _.random(0, 100),
                        midSedan: _.random(0, 100),
                        midPickUp: _.random(0, 100),
                        midSUV: _.random(0, 100),
                        midHatchBack: _.random(0, 100),
                        smallSUV: _.random(0, 100),
                        largeSedan: _.random(0, 100),
                        others: _.random(0, 100)
                    },
                    areaShared: {
                        smallLowCoreSedan: _.random(0, 100),
                        smallLowCoreHatchBack: _.random(0, 100),
                        smallLowCore: _.random(0, 100),
                        midSedan: _.random(0, 100),
                        midPickUp: _.random(0, 100),
                        midSUV: _.random(0, 100),
                        midHatchBack: _.random(0, 100),
                        smallSUV: _.random(0, 100),
                        largeSedan: _.random(0, 100),
                        others: _.random(0, 100)
                    },
                    nationalToyota: {
                        smallLowCoreSedan: _.random(0, 100),
                        smallLowCoreHatchBack: _.random(0, 100),
                        smallLowCore: _.random(0, 100),
                        midSedan: _.random(0, 100),
                        midPickUp: _.random(0, 100),
                        midSUV: _.random(0, 100),
                        midHatchBack: _.random(0, 100),
                        smallSUV: _.random(0, 100),
                        largeSedan: _.random(0, 100),
                        others: _.random(0, 100)
                    },
                    nationalIndustry: {
                        smallLowCoreSedan: _.random(0, 100),
                        smallLowCoreHatchBack: _.random(0, 100),
                        smallLowCore: _.random(0, 100),
                        midSedan: _.random(0, 100),
                        midPickUp: _.random(0, 100),
                        midSUV: _.random(0, 100),
                        midHatchBack: _.random(0, 100),
                        smallSUV: _.random(0, 100),
                        largeSedan: _.random(0, 100),
                        others: _.random(0, 100)
                    },
                    nationalMarketShare: {
                        smallLowCoreSedan: _.random(0, 100),
                        smallLowCoreHatchBack: _.random(0, 100),
                        smallLowCore: _.random(0, 100),
                        midSedan: _.random(0, 100),
                        midPickUp: _.random(0, 100),
                        midSUV: _.random(0, 100),
                        midHatchBack: _.random(0, 100),
                        smallSUV: _.random(0, 100),
                        largeSedan: _.random(0, 100),
                        others: _.random(0, 100)
                    }
                }));
                (new GroupMakertShareSpreadsheet(dataSource)).create().saveAsExcel();

                return unloading(true);
            }, 500);
        }
    },

    mounted () {},

    destroyed () {},

    components: {
        KendoDatepicker,
        KendoDropdown
    }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/modules/download/components/download-group-market-share/download-group-market-share.component.vue